module.exports = __webpack_public_path__ + "static/media/IT_Track_Icon.8a35e235.svg";